"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessagesManager = void 0;
const constants_1 = require("./constants");
function shutdown() {
    if (process.env['NODE_ENV'] == 'test') {
        throw new Error('Application terminated exception');
    }
    process.exit(1);
}
class LogMessagesManager {
    static getAllMessages(format) {
        if (format == 'csv') {
            let str = '';
            let allMetaKeys = {};
            for (let code in LogMessagesManager.allMessages) {
                const meta = LogMessagesManager.allMessages[code].meta;
                if (meta) {
                    for (let key in meta) {
                        allMetaKeys[key] = key;
                    }
                }
            }
            str += `Code,Message,Description`;
            for (let metakey in allMetaKeys) {
                str += ',' + metakey;
            }
            str += '\n';
            for (let code in LogMessagesManager.allMessages) {
                const message = LogMessagesManager.allMessages[code];
                let description = (message.description ? message.description : '');
                let docMessage = message.docMessage;
                description = description.replace(/\"/g, "\"\"");
                docMessage = docMessage.replace(/\"/g, "\"\"");
                const meta = message.meta;
                str += `${message.code},"${docMessage}","${description}"`;
                for (let metakey in allMetaKeys) {
                    str += ',' + ((meta && meta[metakey]) ? meta[metakey] : '');
                }
                str += '\n';
            }
            return str;
        }
        if (format == 'raw') {
            return LogMessagesManager.allMessages;
        }
    }
    static getMessageObject(code) {
        return LogMessagesManager.allMessages[code];
    }
    static setDescriptor(messageString, target, name, audience) {
        var _a;
        let code = LogMessagesManager.getCode(name);
        if (!code) {
            const messageObject = { id: name.toString(), message: "Missing error code for error " + name.toString(), meta: { category: constants_1.eApplicationsErrorCategoryCommon.CODE_DEFECT }, code: constants_1.ErrorCodeCommon.CODE_DEFECT };
            console.error(messageObject);
            shutdown();
        }
        let messageObject = { id: name.toString(), message: messageString, code: code };
        if (((_a = LogMessagesManager.allMessages[messageObject.code]) === null || _a === void 0 ? void 0 : _a.id) != messageObject.id) {
            LogMessagesManager.add(messageObject);
        }
        messageObject = LogMessagesManager.allMessages[code];
        if (audience) {
            if (!messageObject.audience) {
                messageObject.audience = {};
            }
            messageObject.audience[audience] = messageString;
        }
        else {
            messageObject.message = messageString;
        }
        const descriptor = {
            code: 'abc',
            value: (...params) => {
                let err = Object.assign(Object.assign({}, LogMessagesManager.getMessageObject(code)), { message: LogMessagesManager.getFilledMessageString(messageString, params), messageData: LogMessagesManager.getErrorData(messageString, params) });
                if (err === null || err === void 0 ? void 0 : err.audience) {
                    for (let [key, value] of Object.entries(err.audience)) {
                        err.audience[key] = LogMessagesManager.getFilledMessageString(value, params);
                    }
                }
                return err;
            },
            enumerable: true,
            configurable: true,
        };
        Object.defineProperty(target, name, descriptor);
        return descriptor;
    }
    ;
    static setAnonymous(name) {
        const code = LogMessagesManager.getCode(name);
        if (code) {
            LogMessagesManager.allMessages[code] = Object.assign(Object.assign({}, LogMessagesManager.allMessages[code]), { anonymous: true });
        }
    }
    static setDescription(name, text) {
        const code = LogMessagesManager.getCode(name);
        if (code) {
            LogMessagesManager.allMessages[code] = Object.assign(Object.assign({}, LogMessagesManager.allMessages[code]), { description: text });
        }
    }
    static setMeta(name, meta) {
        var _a;
        const code = LogMessagesManager.getCode(name);
        if (code) {
            LogMessagesManager.allMessages[code] = Object.assign(Object.assign({}, LogMessagesManager.allMessages[code]), { meta: Object.assign(Object.assign({}, (_a = LogMessagesManager.allMessages[code]) === null || _a === void 0 ? void 0 : _a.meta), meta) });
        }
    }
    static setHttpStatusCode(name, statusCode) {
        const code = LogMessagesManager.getCode(name);
        if (code) {
            LogMessagesManager.allMessages[code] = Object.assign(Object.assign({}, LogMessagesManager.allMessages[code]), { statusCode: statusCode });
        }
    }
    static add(messageObject) {
        var _a;
        if ((_a = LogMessagesManager.allMessages[messageObject.code]) === null || _a === void 0 ? void 0 : _a.message) {
            console.error({ message: "Duplicate code for log message with " + messageObject.id, meta: { category: constants_1.eApplicationsErrorCategoryCommon.CODE_DEFECT }, code: constants_1.ErrorCodeCommon.CODE_DEFECT });
            shutdown();
        }
        LogMessagesManager.allMessages[messageObject.code] = Object.assign(Object.assign(Object.assign({}, LogMessagesManager.allMessages[messageObject.code]), messageObject), { docMessage: LogMessagesManager.getDocMessageString(messageObject.message) });
    }
    static getDocMessageString(errorString) {
        const pattern = /\$\{([0-9]),?(.*?)\}/g;
        let item;
        let errorStringFilled = errorString;
        while (item = pattern.exec(errorString)) {
            const replace = item[2] ? item[2] : '<value>';
            errorStringFilled = errorStringFilled.replace(item[0], String(replace));
        }
        return errorStringFilled;
    }
    static getFilledMessageString(errorString, params) {
        const pattern = /\$\{([0-9]),?(.*?)\}/g;
        let item;
        let errorStringFilled = errorString;
        while (item = pattern.exec(errorString)) {
            errorStringFilled = errorStringFilled.replace(item[0], String(params[item[1]]));
        }
        return errorStringFilled;
    }
    static getErrorData(errorString, params) {
        const pattern = /\$\{([0-9]),?(.*?)\}/g;
        let item;
        let kvpairs = [];
        while (item = pattern.exec(errorString)) {
            const keyname = item[2] ? item[2] : '<value>';
            const kvpair = { key: keyname, value: String(params[item[1]]) };
            kvpairs.push(kvpair);
        }
        return kvpairs;
    }
    static getCode(name) {
        let itemized = name.toString().split('_');
        return itemized.length > 1 ? itemized[0] : null;
    }
}
exports.LogMessagesManager = LogMessagesManager;
LogMessagesManager.allMessages = {};
